// Produktkarten: Bilder durchschalten (Pfeile, Wischen) und Schnellkauf „+“.
// - Bilder: nur die der gewählten Farbe (Block wie snippets/mil-farbblock.liquid), keine Videos, max. 6.
// - Verlässt die Maus die Karte, kommt das Vorschaubild zurück. Farbwechsel setzt die Galerie zurück.
// - „+“: Größen der gewählten Farbe, Verarbeitung automatisch „Soft“ (sonst erster Wert), dann Warenkorb-Drawer.
// Daten kommen erst bei Bedarf aus /products/<handle>.js. Ein Listener-Satz auf document, damit
// Karten nach Filtern/Sortieren (AJAX) ohne neues Binden funktionieren.
(function() {
  if (window.milKartenGalerieBound) return;
  window.milKartenGalerieBound = true;

  var MAX_BILDER = 6;
  var BREITEN = [165, 360, 533, 720, 940];
  var produkte = {};          // handle -> Promise(Produktdaten)
  var zustand = new WeakMap(); // Karte -> { index, folge, vorschau }

  function karteVon(el) {
    return el && el.closest ? el.closest('.card-product-custom-div') : null;
  }

  function laden(karte) {
    var handle = karte.getAttribute('data-handle');
    if (!handle) return Promise.reject(new Error('kein Handle'));
    if (!produkte[handle]) {
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      produkte[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
        .then(function(r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .catch(function(e) { delete produkte[handle]; throw e; });
    }
    return produkte[handle];
  }

  function optionIndex(produkt, pruefen) {
    for (var i = 0; i < produkt.options.length; i++) {
      var name = String(produkt.options[i].name || '').toLowerCase().replace(/:/g, '').trim();
      if (pruefen(name)) return i;
    }
    return -1;
  }
  function farbIndex(p) { return optionIndex(p, function(n) { return n === 'farbe' || n === 'color' || n === 'colour'; }); }
  function groessenIndex(p) { return optionIndex(p, function(n) { return n.indexOf('größe') === 0 || n.indexOf('groesse') === 0 || n === 'size'; }); }
  function verarbeitungIndex(p) { return optionIndex(p, function(n) { return n.indexOf('verarbeitung') !== -1; }); }

  function gewaehlteFarbe(karte, produkt) {
    var fi = farbIndex(produkt);
    if (fi < 0) return null;
    var input = karte.querySelector('.collection-product-card__swatch input:checked');
    if (input && input.value) return input.value;
    var v = produkt.variants.filter(function(x) { return x.available; })[0] || produkt.variants[0];
    return v ? v.options[fi] : null;
  }

  // Medien-Block der Farbe, gleiche Regeln wie snippets/mil-farbblock.liquid
  function farbBilder(produkt, farbe) {
    var bilder = produkt.media.filter(function(m) { return m.media_type === 'image'; });
    var fi = farbIndex(produkt);
    if (fi < 0 || !farbe) return bilder;
    var werte = produkt.options[fi].values || [];
    if (werte.length < 2) return bilder;
    var starts = [];
    var gewaehlt = null;
    for (var i = 0; i < werte.length; i++) {
      var v = produkt.variants.filter(function(x) { return x.options[fi] === werte[i]; })[0];
      var pos = v && v.featured_media ? v.featured_media.position : null;
      if (!pos || starts.indexOf(pos) !== -1) return bilder;
      starts.push(pos);
      if (werte[i] === farbe) gewaehlt = pos;
    }
    if (gewaehlt === null) return bilder;
    starts.sort(function(a, b) { return a - b; });
    var k = starts.indexOf(gewaehlt);
    var von = k === 0 ? 1 : gewaehlt;
    var bis = k < starts.length - 1 ? starts[k + 1] - 1 : Infinity;
    return bilder.filter(function(m) { return m.position >= von && m.position <= bis; });
  }

  function dateiname(url) {
    return String(url || '').split('?')[0].split('/').pop();
  }

  function mitBreite(url, w) {
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  function bildEintrag(m) {
    var url = (m.preview_image && m.preview_image.src) || m.src;
    var max = (m.preview_image && m.preview_image.width) || m.width || 1066;
    var srcset = BREITEN.filter(function(w) { return w <= max; }).map(function(w) { return mitBreite(url, w) + ' ' + w + 'w'; });
    return { src: mitBreite(url, 533), srcset: srcset.join(', '), alt: m.alt || '', name: dateiname(url) };
  }

  function kartenBild(karte) {
    return karte.querySelector('.card__media img');
  }

  // Folge = [Vorschaubild, weitere Bilder der Farbe ohne das Vorschaubild], max. 6
  function folgeAufbauen(karte, produkt) {
    var img = kartenBild(karte);
    var vorschau = { src: img.getAttribute('src'), srcset: img.getAttribute('srcset') || '', alt: img.getAttribute('alt') || '', name: dateiname(img.getAttribute('src')) };
    var rest = farbBilder(produkt, gewaehlteFarbe(karte, produkt)).map(bildEintrag).filter(function(b) { return b.name !== vorschau.name; });
    return [vorschau].concat(rest).slice(0, MAX_BILDER);
  }

  function zeigen(karte, eintrag) {
    var img = kartenBild(karte);
    if (!img || !eintrag) return;
    img.removeAttribute('loading');
    img.srcset = eintrag.srcset;
    img.src = eintrag.src;
    img.alt = eintrag.alt;
  }

  function vorladen(karte, eintrag) {
    var img = kartenBild(karte);
    if (!eintrag || !img) return;
    var vor = new Image();
    vor.sizes = img.sizes;
    vor.srcset = eintrag.srcset;
    vor.src = eintrag.src;
  }

  function blaettern(karte, richtung) {
    if (!kartenBild(karte)) return;
    laden(karte).then(function(produkt) {
      var z = zustand.get(karte);
      if (!z || !z.folge) {
        z = { index: 0, folge: folgeAufbauen(karte, produkt) };
        zustand.set(karte, z);
      }
      var n = z.folge.length;
      if (n < 2) return;
      z.index = (z.index + richtung + n) % n;
      zeigen(karte, z.folge[z.index]);
      vorladen(karte, z.folge[(z.index + richtung + n) % n]);
    }).catch(function() {});
  }

  function zuruecksetzen(karte) {
    var z = zustand.get(karte);
    if (z && z.folge && z.index !== 0) zeigen(karte, z.folge[0]);
    zustand.delete(karte);
  }

  // ---------- Pfeile ----------
  document.addEventListener('click', function(e) {
    var pfeil = e.target.closest && e.target.closest('[data-mil-pfeil]');
    if (!pfeil) return;
    var karte = karteVon(pfeil);
    if (!karte) return;
    e.preventDefault();
    e.stopPropagation();
    blaettern(karte, parseInt(pfeil.getAttribute('data-mil-pfeil'), 10) || 1);
  });

  // ---------- Maus: Daten vorladen beim Betreten, Vorschaubild beim Verlassen ----------
  document.addEventListener('mouseover', function(e) {
    var karte = karteVon(e.target);
    if (!karte || karte.hasAttribute('data-mil-maus')) return;
    karte.setAttribute('data-mil-maus', '');
    if (karte.classList.contains('mil-karte--galerie')) laden(karte).catch(function() {});
    karte.addEventListener('mouseleave', function() {
      zuruecksetzen(karte);
      schnellkaufSchliessen(karte);
    });
  });

  // ---------- Farbwechsel: Galerie neu aufbauen ----------
  document.addEventListener('change', function(e) {
    if (!e.target.closest || !e.target.closest('.collection-product-card__swatch')) return;
    var karte = karteVon(e.target);
    if (!karte) return;
    zustand.delete(karte);
    var panel = karte.querySelector('[data-mil-schnellkauf]');
    if (panel && !panel.hidden) schnellkaufOeffnen(karte);
  });

  // ---------- Wischen (Touch) ----------
  var wisch = null;
  var klickSperre = 0;
  document.addEventListener('touchstart', function(e) {
    var karte = karteVon(e.target);
    // Der Finger trifft meist den Kartenlink, der über dem Bild liegt: daher den Rahmen mit Bild prüfen
    var rahmen = e.target.closest('.card-wrapper');
    if (!karte || !karte.classList.contains('mil-karte--galerie') || !rahmen || !rahmen.querySelector('.card__media')) { wisch = null; return; }
    if (e.target.closest('[data-mil-schnellkauf], [data-mil-plus], [data-mil-pfeil]')) { wisch = null; return; }
    var t = e.touches[0];
    wisch = { karte: karte, x: t.clientX, y: t.clientY };
  }, { passive: true });
  document.addEventListener('touchend', function(e) {
    if (!wisch) return;
    var t = e.changedTouches[0];
    var dx = t.clientX - wisch.x;
    var dy = t.clientY - wisch.y;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
      blaettern(wisch.karte, dx < 0 ? 1 : -1);
      klickSperre = Date.now();
    }
    wisch = null;
  }, { passive: true });
  // Nach einem Wisch nicht versehentlich die Produktseite öffnen
  document.addEventListener('click', function(e) {
    if (Date.now() - klickSperre < 400 && karteVon(e.target)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  // ---------- Schnellkauf ----------
  function schnellkaufSchliessen(karte) {
    var panel = karte.querySelector('[data-mil-schnellkauf]');
    var plus = karte.querySelector('[data-mil-plus]');
    if (panel) panel.hidden = true;
    if (plus) plus.setAttribute('aria-expanded', 'false');
  }

  function text(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function schnellkaufOeffnen(karte) {
    var panel = karte.querySelector('[data-mil-schnellkauf]');
    var plus = karte.querySelector('[data-mil-plus]');
    if (!panel) return;
    laden(karte).then(function(produkt) {
      var fi = farbIndex(produkt);
      var gi = groessenIndex(produkt);
      var vi = verarbeitungIndex(produkt);
      var farbe = gewaehlteFarbe(karte, produkt);
      var feste = produkt.options.map(function(opt, i) {
        if (i === fi) return farbe;
        if (i === gi) return null;
        var werte = opt.values || [];
        if (i === vi) {
          var soft = werte.filter(function(w) { return /^soft/i.test(w); })[0];
          return soft || werte[0];
        }
        return werte[0];
      });
      var passend = produkt.variants.filter(function(v) {
        return v.options.every(function(o, i) { return feste[i] === null || o === feste[i]; });
      });

      // Ohne Größenwahl und eindeutig: direkt in den Warenkorb
      if (gi < 0 && passend.length === 1) {
        if (passend[0].available) hinzufuegen(karte, passend[0].id, plus);
        return;
      }

      var kopf = [];
      if (farbe) kopf.push(farbe);
      if (vi >= 0) kopf.push(String(feste[vi]).split(' ')[0]);
      kopf.push(gi >= 0 ? 'Größe wählen' : 'Variante wählen');

      var chips = (gi >= 0 ? produkt.options[gi].values : passend.map(function(v) { return v.title; })).map(function(wert) {
        var v = gi >= 0 ? passend.filter(function(x) { return x.options[gi] === wert; })[0] : passend.filter(function(x) { return x.title === wert; })[0];
        var ok = v && v.available;
        return '<button type="button" class="mil-karte__groesse"' + (ok ? ' data-mil-variante="' + v.id + '"' : ' disabled aria-disabled="true"') +
          ' aria-label="' + text(wert) + (ok ? '' : ', nicht verfügbar') + '">' + text(wert) + '</button>';
      }).join('');

      panel.innerHTML =
        '<div class="mil-karte__schnellkauf-kopf"><span>' + text(kopf.join(' · ')) + '</span>' +
        '<button type="button" class="mil-karte__schliessen" data-mil-schliessen aria-label="Schließen">×</button></div>' +
        '<div class="mil-karte__groessen" role="group" aria-label="' + text(kopf.join(' · ')) + '">' + chips + '</div>' +
        '<p class="mil-karte__meldung" role="status" hidden></p>';
      panel.hidden = false;
      if (plus) plus.setAttribute('aria-expanded', 'true');
      var erster = panel.querySelector('[data-mil-variante]');
      if (erster && document.activeElement === plus) erster.focus();
    }).catch(function() {
      window.location.href = karte.querySelector('a[id^="CardLink-"]').href;
    });
  }

  function meldung(karte, nachricht) {
    var m = karte.querySelector('.mil-karte__meldung');
    if (!m) return;
    m.textContent = nachricht;
    m.hidden = !nachricht;
  }

  function hinzufuegen(karte, variantId, knopf) {
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var routes = window.routes || {};
    var config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: { Accept: 'application/javascript' } };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    var daten = new FormData();
    daten.append('id', variantId);
    daten.append('quantity', 1);
    if (cart) {
      daten.append('sections', cart.getSectionsToRender().map(function(s) { return s.id; }));
      daten.append('sections_url', window.location.pathname);
      cart.setActiveElement(document.activeElement);
    }
    config.body = daten;
    if (knopf) knopf.setAttribute('aria-busy', 'true');
    karte.classList.add('mil-karte--laedt');
    fetch(routes.cart_add_url || '/cart/add', config)
      .then(function(r) { return r.json(); })
      .then(function(antwort) {
        if (antwort.status) {
          meldung(karte, antwort.description || antwort.message || 'Konnte nicht hinzugefügt werden.');
          return;
        }
        if (!cart) {
          window.location = routes.cart_url || '/cart';
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mil-karte', productVariantId: variantId, cartData: antwort });
        }
        schnellkaufSchliessen(karte);
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(antwort);
      })
      .catch(function() { meldung(karte, 'Konnte nicht hinzugefügt werden.'); })
      .finally(function() {
        if (knopf) knopf.removeAttribute('aria-busy');
        karte.classList.remove('mil-karte--laedt');
      });
  }

  document.addEventListener('click', function(e) {
    if (!e.target.closest) return;
    var plus = e.target.closest('[data-mil-plus]');
    var groesse = e.target.closest('[data-mil-variante]');
    var schliessen = e.target.closest('[data-mil-schliessen]');
    var imPanel = e.target.closest('[data-mil-schnellkauf]');
    if (plus || groesse || schliessen || imPanel) {
      e.preventDefault();
      e.stopPropagation();
    }
    var karte = karteVon(e.target);
    if (plus) {
      var panel = karte.querySelector('[data-mil-schnellkauf]');
      if (panel && !panel.hidden) schnellkaufSchliessen(karte);
      else schnellkaufOeffnen(karte);
    } else if (groesse) {
      hinzufuegen(karte, groesse.getAttribute('data-mil-variante'), groesse);
    } else if (schliessen) {
      schnellkaufSchliessen(karte);
      var p = karte.querySelector('[data-mil-plus]');
      if (p) p.focus();
    }
    // Klick außerhalb schließt offene Schnellkauf-Leisten
    document.querySelectorAll('[data-mil-schnellkauf]:not([hidden])').forEach(function(offen) {
      var k = karteVon(offen);
      if (k && k !== karte) schnellkaufSchliessen(k);
    });
  });

  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;
    var offen = document.activeElement && document.activeElement.closest && document.activeElement.closest('[data-mil-schnellkauf]');
    var karte = karteVon(offen || document.activeElement);
    if (!karte) return;
    schnellkaufSchliessen(karte);
    var p = karte.querySelector('[data-mil-plus]');
    if (p) p.focus();
  });
  // ---------- Quick-View (Augen-Symbol auf der Karte, nur Desktop) ----------
  // Fenster mit Galerie der gewählten Farbe, allen Optionen, Preis, Kurztext und „In den Warenkorb“.
  // Daten erst beim Öffnen (laden()), natives <dialog>: Esc und Fokusfalle vom Browser.
  var qv = null;
  var qvZustand = null;

  function qvAufbauen() {
    if (qv) return qv;
    qv = document.createElement('dialog');
    qv.className = 'mil-qv';
    qv.setAttribute('aria-labelledby', 'MilQvTitel');
    qv.innerHTML =
      '<div class="mil-qv__inhalt">' +
      '<button type="button" class="mil-qv__zu" data-mil-qv-zu aria-label="Schließen">×</button>' +
      '<div class="mil-qv__galerie"><img class="mil-qv__bild" alt="" width="600" height="600"><div class="mil-qv__thumbs" role="list"></div></div>' +
      '<div class="mil-qv__info">' +
      '<h2 class="mil-qv__titel" id="MilQvTitel"></h2>' +
      '<p class="mil-qv__preis"></p>' +
      '<div class="mil-qv__optionen"></div>' +
      '<p class="mil-qv__status" role="status"></p>' +
      '<button type="button" class="mil-qv__kaufen" data-mil-qv-kaufen>In den Warenkorb</button>' +
      '<p class="mil-qv__liefer">Lieferung in ca. 5–6 Werktagen</p>' +
      '<p class="mil-qv__text"></p>' +
      '<a class="mil-qv__link" href="#">Alle Details ansehen</a>' +
      '</div></div>';
    document.body.appendChild(qv);
    // Klick auf den abgedunkelten Hintergrund schließt
    qv.addEventListener('click', function(e) { if (e.target === qv) qv.close(); });
    return qv;
  }

  function qvVariante() {
    var z = qvZustand;
    return z.produkt.variants.filter(function(v) {
      return v.options.every(function(o, i) { return z.wahl[i] === o; });
    })[0] || null;
  }

  function qvKurzname(i, w) {
    return i === verarbeitungIndex(qvZustand.produkt) ? String(w).split(' ')[0] : String(w);
  }

  function qvGalerie() {
    var z = qvZustand;
    var fi = farbIndex(z.produkt);
    var bilder = farbBilder(z.produkt, fi >= 0 ? z.wahl[fi] : null).slice(0, 8).map(bildEintrag);
    if (!bilder.length) bilder = z.produkt.media.filter(function(m) { return m.media_type === 'image'; }).slice(0, 8).map(bildEintrag);
    var haupt = qv.querySelector('.mil-qv__bild');
    var zeigeBild = function(b) {
      if (!b) return;
      haupt.sizes = '(min-width: 990px) 480px, 90vw';
      haupt.srcset = b.srcset;
      haupt.src = b.src;
      haupt.alt = b.alt;
    };
    zeigeBild(bilder[0]);
    qv.querySelector('.mil-qv__thumbs').innerHTML = bilder.map(function(b, i) {
      var klein = b.srcset.split(', ')[0].split(' ')[0];
      return '<button type="button" class="mil-qv__thumb" role="listitem" data-mil-qv-thumb="' + i + '" aria-label="Bild ' + (i + 1) + '"' + (i === 0 ? ' aria-current="true"' : '') + '>' +
        '<img src="' + text(klein) + '" alt="" width="60" height="60" loading="lazy"></button>';
    }).join('');
    z.bilder = bilder;
    z.zeigeBild = zeigeBild;
  }

  function qvOptionen() {
    var z = qvZustand;
    var p = z.produkt;
    var html = p.options.map(function(opt, i) {
      var werte = opt.values || [];
      if (werte.length < 2) return '';
      var name = String(opt.name || '').replace(/:/g, '').replace(/ bitte Auswählen/i, '').trim();
      var knoepfe = werte.map(function(w) {
        // möglich, wenn es mit den übrigen gewählten Optionen eine verfügbare Variante gibt
        var moeglich = p.variants.some(function(v) {
          return v.available && v.options[i] === w && v.options.every(function(o, j) { return j === i || z.wahl[j] === null || z.wahl[j] === o; });
        });
        return '<button type="button" class="mil-qv__wert" data-mil-qv-option="' + i + '" data-wert="' + text(w) + '" aria-pressed="' + (z.wahl[i] === w) + '"' +
          (moeglich ? '' : ' data-aus') + '>' + text(qvKurzname(i, w)) + '</button>';
      }).join('');
      return '<fieldset class="mil-qv__gruppe"><legend>' + text(name) + (z.wahl[i] ? ': ' + text(qvKurzname(i, z.wahl[i])) : '') + '</legend>' +
        '<div class="mil-qv__werte">' + knoepfe + '</div></fieldset>';
    }).join('');
    qv.querySelector('.mil-qv__optionen').innerHTML = html;
    qvKaufstatus();
  }

  var qvPreisformat = new Intl.NumberFormat('de-DE', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' });
  function qvKaufstatus() {
    var z = qvZustand;
    var v = qvVariante();
    var knopf = qv.querySelector('[data-mil-qv-kaufen]');
    var preis = qv.querySelector('.mil-qv__preis');
    var fehlt = z.produkt.options.map(function(o, i) { return z.wahl[i] === null ? String(o.name).replace(/:/g, '').trim() : null; }).filter(Boolean);
    preis.textContent = v ? qvPreisformat.format(v.price / 100) : (z.produkt.price_varies ? 'ab ' : '') + qvPreisformat.format(z.produkt.price_min / 100);
    if (fehlt.length) { knopf.disabled = true; knopf.textContent = fehlt[0] + ' wählen'; }
    else if (!v || !v.available) { knopf.disabled = true; knopf.textContent = 'Nicht verfügbar'; }
    else { knopf.disabled = false; knopf.textContent = 'In den Warenkorb'; }
  }

  function qvOeffnen(karte) {
    var d = qvAufbauen();
    d.querySelector('.mil-qv__titel').textContent = '';
    d.querySelector('.mil-qv__optionen').innerHTML = '';
    d.querySelector('.mil-qv__thumbs').innerHTML = '';
    d.querySelector('.mil-qv__text').textContent = '';
    d.querySelector('.mil-qv__status').textContent = 'Lädt …';
    d.showModal();
    laden(karte).then(function(p) {
      var fi = farbIndex(p), gi = groessenIndex(p), vi = verarbeitungIndex(p);
      var farbe = gewaehlteFarbe(karte, p);
      var wahl = p.options.map(function(opt, i) {
        var werte = opt.values || [];
        if (werte.length === 1) return werte[0];
        if (i === fi) return farbe;
        if (i === vi) return werte.filter(function(w) { return /^soft/i.test(w); })[0] || werte[0];
        if (i === gi) return null; // Größe wählt der Kunde selbst
        return werte[0];
      });
      qvZustand = { produkt: p, wahl: wahl, karte: karte };
      d.querySelector('.mil-qv__titel').textContent = String(p.title).split(' | ')[0];
      d.querySelector('.mil-qv__status').textContent = '';
      var t = document.createElement('div');
      t.innerHTML = p.description || '';
      var kurz = (t.textContent || '').replace(/\s+/g, ' ').trim();
      d.querySelector('.mil-qv__text').textContent = kurz.length > 260 ? kurz.slice(0, 257).replace(/\s\S*$/, '') + ' …' : kurz;
      d.querySelector('.mil-qv__link').href = p.url;
      qvGalerie();
      qvOptionen();
    }).catch(function() {
      d.querySelector('.mil-qv__status').textContent = 'Konnte nicht geladen werden.';
    });
  }

  function qvKaufen(knopf) {
    var v = qvVariante();
    if (!v || !v.available) return;
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var routes = window.routes || {};
    var config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: { Accept: 'application/javascript' } };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    var daten = new FormData();
    daten.append('id', v.id);
    daten.append('quantity', 1);
    if (cart) {
      daten.append('sections', cart.getSectionsToRender().map(function(s) { return s.id; }));
      daten.append('sections_url', window.location.pathname);
    }
    config.body = daten;
    knopf.disabled = true;
    knopf.setAttribute('aria-busy', 'true');
    fetch(routes.cart_add_url || '/cart/add', config)
      .then(function(r) { return r.json(); })
      .then(function(antwort) {
        if (antwort.status) { qv.querySelector('.mil-qv__status').textContent = antwort.description || 'Konnte nicht hinzugefügt werden.'; return; }
        if (!cart) { window.location = routes.cart_url || '/cart'; return; }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mil-qv', productVariantId: v.id, cartData: antwort });
        }
        qv.close();
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        cart.renderContents(antwort);
      })
      .catch(function() { qv.querySelector('.mil-qv__status').textContent = 'Konnte nicht hinzugefügt werden.'; })
      .finally(function() { knopf.removeAttribute('aria-busy'); qvKaufstatus(); });
  }

  document.addEventListener('click', function(e) {
    if (!e.target.closest) return;
    var auf = e.target.closest('[data-mil-qv]');
    if (auf) {
      e.preventDefault();
      e.stopPropagation();
      var karte = karteVon(auf);
      if (karte) qvOeffnen(karte);
      return;
    }
    if (!qv || !qv.open || !qv.contains(e.target)) return;
    if (e.target.closest('[data-mil-qv-zu]')) { qv.close(); return; }
    var thumb = e.target.closest('[data-mil-qv-thumb]');
    if (thumb) {
      var i = parseInt(thumb.getAttribute('data-mil-qv-thumb'), 10);
      qvZustand.zeigeBild(qvZustand.bilder[i]);
      qv.querySelectorAll('[data-mil-qv-thumb]').forEach(function(t) { t.removeAttribute('aria-current'); });
      thumb.setAttribute('aria-current', 'true');
      return;
    }
    var wert = e.target.closest('[data-mil-qv-option]');
    if (wert) {
      var idx = parseInt(wert.getAttribute('data-mil-qv-option'), 10);
      qvZustand.wahl[idx] = wert.getAttribute('data-wert');
      if (idx === farbIndex(qvZustand.produkt)) qvGalerie();
      qvOptionen();
      return;
    }
    var kaufen = e.target.closest('[data-mil-qv-kaufen]');
    if (kaufen) qvKaufen(kaufen);
  });
})();
